import get from 'lodash/get';

export default function getCreateToken(state: object) {
  return get(state, ['page', 'data', 'apis', 'pass.create_token'], {
    url: '',
    method: 'POST'
  });
}
